import { baseInputClasses } from '@/components/shared/input';
import { cn } from '@/lib/utils';
import React from 'react';

import { SelectProps } from './Select.types';
import { Icon } from '../Icon/Icon';

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ className = '', ...props }, ref) => (
    <div className="relative block w-full min-w-0">
      <Icon
        icon="ChevronDown"
        className="pointer-events-none absolute right-0 m-300 h-400 w-400"
      />
      <select
        {...props}
        ref={ref}
        className={cn(baseInputClasses, 'appearance-none', className)}
      />
    </div>
  ),
);

Select.displayName = 'Select';
